import { RegistryCategoryMatrixID } from '../types/registry';
import { useRegistryItems } from './useRegistryItems';

export const useRootCauses = (eventRootCauseIds?: string[]) => {
  return useRegistryItems(RegistryCategoryMatrixID.ROOT_CAUSE_MATRIX_ID, eventRootCauseIds);
};
